var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "energyLabel" },
    [
      _c("div", { staticClass: "picto" }, [
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _vm.energyLabel.labelImage
            ? _c(
                "button",
                {
                  staticClass: "border-0 bg-transparent",
                  attrs: {
                    "data-bs-target": "#modal-energyLabel",
                    "data-bs-toggle": "modal",
                    "data-oevent-category": "fiche_detail_equipement_conso",
                    "data-oevent-label":
                      "indice_" + _vm.energyLabel.efficiencyClass,
                    "data-oevent-action": _vm.energyLabel.sheetUrl,
                    title:
                      "Ouvrir la fiche d'information énergétique du produit",
                  },
                },
                [
                  _c("img", {
                    staticClass: "align-self-center my-1",
                    attrs: {
                      alt:
                        "terminal de classe énergétique " +
                        _vm.energyLabel.efficiencyClass,
                      src: _vm.energyLabel.efficiencyClassImage,
                    },
                  }),
                ]
              )
            : _vm.energyLabel.sheetUrl
            ? _c(
                "a",
                {
                  attrs: {
                    href: _vm.sheetHref,
                    target: "_blank",
                    "data-oevent-category": "fiche_detail_equipement_conso",
                    "data-oevent-label":
                      "indice_" + _vm.energyLabel.efficiencyClass,
                    "data-oevent-action": _vm.energyLabel.sheetUrl,
                    title:
                      "Ouvrir la fiche d'information énergétique du produit",
                  },
                },
                [
                  _c("img", {
                    staticClass: "align-self-center my-1",
                    attrs: {
                      alt:
                        "terminal de classe énergétique " +
                        _vm.energyLabel.efficiencyClass,
                      src: _vm.energyLabel.efficiencyClassImage,
                    },
                  }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.energyLabel.labelImage || _vm.energyLabel.sheetUrl
            ? _c(
                "a",
                {
                  staticClass: "ps-1",
                  attrs: { href: _vm.sheetHref, target: "_blank" },
                },
                [
                  _c("strong", {
                    domProps: {
                      innerHTML: _vm._s(_vm.energyLabel.popinLinkLabel),
                    },
                  }),
                ]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "ob1-popin-modal2",
        {
          attrs: {
            id: "modal-energyLabel",
            "aria-labelledby": "modal-label-energyLabel",
          },
        },
        [
          _c("p", {
            staticClass: "h4",
            attrs: { id: "modal-label-energyLabel" },
            domProps: { innerHTML: _vm._s(_vm.energyLabel.popinTitle) },
          }),
          _vm._v(" "),
          _c("img", {
            staticClass: "w-50",
            attrs: { alt: "", src: _vm.energyLabel.labelImage },
          }),
          _vm._v(" "),
          _vm.energyLabel.sheetUrl
            ? _c("ob1-liens", {
                attrs: {
                  "with-arrow": true,
                  "is-large": true,
                  text: _vm.energyLabel.sheetLinkLabel,
                  href: _vm.sheetHref,
                  target: "_blank",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }